import { CustomButton } from "@/components/ui/Buttons";
import VideoPlayerV3 from "@/components/ui/VideoPlayerV3";
import { TProductStructureCard } from "./ProductStructureType";
import { Dispatch, SetStateAction } from "react";

type SimilarStructureProps = {
  data: TProductStructureCard;
  currentlyPlaying: string | null;
  setCurrentlyPlaying: Dispatch<SetStateAction<string | null>>;
};

const SimilarStructure = ({
  data,
  currentlyPlaying,
  setCurrentlyPlaying,
}: SimilarStructureProps) => {
  if (!data.videos || data.videos.length === 0) {
    return (
      <div className="bg-[#FDFDFD] border border-[#DDDDDD] py-6 px-[18px] rounded-lg mb-3">
        <p className="text-[#A7A7A7] text-sm text-center">
          No similar structure videos available
        </p>
      </div>
    );
  }

  return (
    <div className="bg-[#FDFDFD] border border-[#DDDDDD] py-3 px-[18px] rounded-lg mb-3">
      <div className="mb-3 flex items-center gap-x-10 justify-between">
        <p className="text-[#363636] text-sm leading-6 tracking-normal font-medium ">
          Similar Structure
        </p>
        <CustomButton
          variant="outline"
          padding="4.5px 10px"
          borderRadius="8px"
          border="1px solid #000000"
          color="#363636"
          fontSize="13px"
          fontWeight="500"
          className="leading-[125%] tracking-[-0.75%]"
        >
          View More
        </CustomButton>
      </div>
      <div className="grid grid-cols-2 gap-x-[31px] w-full overflow-x-auto">
        {data.videos.map((item, videoIndex) => (
          <div key={videoIndex} className="w-full min-w-[120px] flex-shrink-0">
            <div className="h-[122px]">
              <VideoPlayerV3
                thumbnailUrl={item.thumbnail}
                url={item.video_url}
                currentlyPlaying={currentlyPlaying}
                setCurrentlyPlaying={setCurrentlyPlaying}
                className="w-full h-full rounded-[8px] object-cover"
              />
            </div>
            <div className="border border-[#F2F2F2] rounded-[8px] py-2 w-full py-auto mt-2.5 space-y-1 h-[50px]">
              {item.brand_name && (
                <p className="text-[#363636] text-[13px] leading-[125%] tracking-[-0.75%] text-center truncate px-2">
                  {item.brand_name}
                </p>
              )}

              {item.days_running === 0 ? (
                <p className="text-[#667085] text-[10px] leading-[125%] tracking-[-0.75%] text-center">
                  0 days running
                </p>
              ) : (
                <p className="text-[#667085] text-[10px] leading-[125%] tracking-[-0.75%] text-center">
                  {item.days_running} days running
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SimilarStructure;
